import React from "react";
import { Button, TextArea } from "semantic-ui-react";
import { Utils } from "../../common/utils";
import EmailAddressSearch from "./EmailAddressSearch";

interface Props {
  onEmailsSelected: (emails: string) => void
  initialEmails: string
  suggestedApiInstruction: server.dto.ListContactAddressBookToItemInstruction
}

const SelectMultipleEmailAddresses = (props: Props) => {
  const [output, setOutput] = React.useState<string>(props.initialEmails);

  const onOutputBlur = () => {
    setOutput(Utils.processManualRecipientsString(output));
  };

  const onContactClick = (_: server.dto.ContactAddressBookEntry, email: string) => {
    const result = Utils.processManualRecipientsString(output + " " + email);
    setOutput(result);
  };

  return <EmailAddressSearch
    suggestedApiInstruction={props.suggestedApiInstruction}
    onContactClick={onContactClick}
  >
    <div>
      <TextArea
        onBlur={onOutputBlur}
        className="margin-bottom"
        rows={4}
        value={output}
        onChange={(_, { value }) => { setOutput(value.toString()); }}
      />
    </div>

    <div className="flex margintop">
      <div className="grow1"></div>
      <Button primary onClick={() => { props.onEmailsSelected(output); }}>{RESX.Buttons.btnSelect}</Button>
    </div>
  </EmailAddressSearch>;
};

export default SelectMultipleEmailAddresses;